import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const NextIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <path
            d="M23.4579 11.1386C24.0987 11.7811 24.0987 12.8312 23.4579 13.4806L14.7318 22.3169C14.0978 22.9663 13.0616 22.9594 12.4208 22.3169C11.78 21.6744 11.78 20.6243 12.4208 19.9748L18.3518 13.9642H1.57461C0.667919 13.9642 -0.0615234 13.225 -0.0615234 12.3061C-0.0615234 11.3873 0.667919 10.648 1.57461 10.648L18.3518 10.6411L12.4208 4.63052C11.78 3.98801 11.7868 2.93788 12.4208 2.28846C13.0548 1.63904 14.091 1.63904 14.7318 2.28846L23.4579 11.1386Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default NextIcon
